import { CreditCard, Smartphone } from "lucide-react";
import { fmtEur } from "@/lib/utils";

export const CARD_COUNTRIES = [
  ["FR", "France"], ["BE", "Belgique"], ["CH", "Suisse"], ["DE", "Allemagne"], ["IT", "Italie"], ["ES", "Espagne"],
  ["GB", "Royaume-Uni"], ["US", "Etats-Unis"], ["CA", "Canada"], ["MA", "Maroc"],
];

/* Toggle Mobile Money / carte internationale (client en Europe, Amérique…) + champs facturation requis par CinetPay. */
export const PaymentMethodPicker = ({ value, onChange, amount }) => {
  const card = value.payment_method === "card";
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="mb-4" data-testid="payment-method-picker">
      <div className="grid grid-cols-2 gap-2">
        <button type="button" onClick={() => set({ payment_method: "mobile_money" })} data-testid="pay-method-mobile"
          className={`flex items-center justify-center gap-2 py-2.5 rounded-2xl border-2 text-sm font-bold transition ${!card ? "border-amber-400 bg-amber-50" : "border-[var(--line)] bg-white"}`}>
          <Smartphone size={15} /> Mobile Money
        </button>
        <button type="button" onClick={() => set({ payment_method: "card" })} data-testid="pay-method-card"
          className={`flex items-center justify-center gap-2 py-2.5 rounded-2xl border-2 text-sm font-bold transition ${card ? "border-amber-400 bg-amber-50" : "border-[var(--line)] bg-white"}`}>
          <CreditCard size={15} /> Carte (depuis l&apos;etranger)
        </button>
      </div>
      {!card && (
        <div className="mb-3 text-sm" data-testid="third-party-wave-block">
          <label className="inline-flex items-center gap-2 font-semibold">
            <input type="checkbox" checked={!!value.use_third_party} onChange={(e) => set({ use_third_party: e.target.checked, payer_phone: e.target.checked ? value.payer_phone || "" : "" })} data-testid="third-party-wave-toggle" />
            Payer avec le compte Wave / Mobile Money d&apos;un proche
          </label>
          {value.use_third_party && (
            <>
              <input placeholder="Numéro du proche (ex. 07 00 00 00 00)" value={value.payer_phone || ""} onChange={(e) => set({ payer_phone: e.target.value })} className="mt-2" data-testid="third-party-wave-phone" />
              <p className="text-[11px] text-amber-700 font-semibold">Le titulaire de ce numéro recevra la demande et devra valider lui-même le paiement sur son téléphone. Vérifiez bien le numéro.</p>
            </>
          )}
        </div>
      )}
      {card && (
        <div className="mt-3 grid grid-cols-2 gap-2" data-testid="card-billing-fields">
          <select value={value.customer_country || "FR"} onChange={(e) => set({ customer_country: e.target.value })} data-testid="card-country-select" className="col-span-2 !py-2.5">
            {CARD_COUNTRIES.map(([c, l]) => <option key={c} value={c}>{l}</option>)}
          </select>
          <input placeholder="Ville *" value={value.customer_city || ""} onChange={(e) => set({ customer_city: e.target.value })} data-testid="card-city-input" className="!py-2.5 px-3 rounded-2xl border-2 border-[var(--line)]" />
          <input placeholder="Code postal" value={value.customer_zip || ""} onChange={(e) => set({ customer_zip: e.target.value })} data-testid="card-zip-input" className="!py-2.5 px-3 rounded-2xl border-2 border-[var(--line)]" />
          <input placeholder="Adresse" value={value.customer_address || ""} onChange={(e) => set({ customer_address: e.target.value })} data-testid="card-address-input" className="col-span-2 !py-2.5 px-3 rounded-2xl border-2 border-[var(--line)]" />
          <p className="col-span-2 text-[11px] text-[var(--ink-soft)]">Visa / Mastercard via CinetPay. Montant en FCFA (XOF){amount ? <b data-testid="card-eur-equivalent"> {fmtEur(amount)}</b> : ""}, conversion automatique par votre banque (taux fixe 1 € = 655,957 FCFA).</p>
        </div>
      )}
    </div>
  );
};
